module.exports = __webpack_public_path__ + "img/40_38_033_550.a5074dde.jpg";